import React from "react"
import PropTypes from "prop-types"
import { createStyles, makeStyles, useTheme } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"
import { Container } from "@material-ui/core"
import Hero from "./hero"
import Navbar from "../elements/navigation"

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      overflow: "hidden",
    },
  })
)

const Layout = ({ children, splash, light }) => {
  const classes = useStyles()
  const hero = splash ? (
    <Hero
      className="splash"
      heading="Steve Newman"
      subHeading="Full Stack Developer"
    />
  ) : null

  return (
    <>
      <Navbar light={light} />
      {hero}
      <div className={classes.root}>
        <Container component="div" maxWidth="lg">
          <Grid component="main" item xs={12}>
            {children}
          </Grid>
        </Container>
      </div>

      <footer></footer>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
